export default __webpack_public_path__ + "static/media/icon_whatsapp.efd40d83.svg";